import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

// MODULES
import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { DirectiveModule } from '../shared/directives/directive.module';
import { SharedModule } from '../shared/shared.module';
import { UiModule } from '../ui/ui.module';

import { ChannelModule } from './../channel/channel.module';
import { PipeModule } from './../shared/pipes/pipe.module';

// PIPES
import { ParseJsonStringPipe } from '../shared/pipes/parse-json-string.pipe';

//COMPONENTS
import {
    AppIntegrationAccountsComponent,
    AppIntegrationShippingOptionsFormComponent,
    AppIntegrationPresetFormComponent,
    TrackstarConnectWmsButtonComponent,
    HubSpotConnectButtonComponent,
    AppIntegrationAccountFormComponent,
    AppIntegrationAccountManageComponent,
    AppIntegrationAccountManageProductsComponent,
    AppIntegrationAccountManageCompaniesComponent,
    AppIntegrationAccountManageCompaniesGridComponent,
    AppIntegrationAccountLocationComponent,
    AppIntegrationAccountProductFilterFormComponent,
    AppIntegrationAccountBulkCreateProductsModalComponent,
} from './components';
import { AppIntegrationIsAttribute } from './pipes/app-integration-is-attribute.pipe';

const components = [
  AppIntegrationAccountsComponent,
  AppIntegrationShippingOptionsFormComponent,
  AppIntegrationPresetFormComponent,
  TrackstarConnectWmsButtonComponent,
  HubSpotConnectButtonComponent,
  AppIntegrationAccountFormComponent,
  AppIntegrationAccountManageComponent,
  AppIntegrationAccountManageProductsComponent,
  AppIntegrationAccountManageCompaniesComponent,
  AppIntegrationAccountManageCompaniesGridComponent,
  AppIntegrationAccountLocationComponent,
  AppIntegrationAccountProductFilterFormComponent,
  AppIntegrationAccountBulkCreateProductsModalComponent,
];

const angularModules = [
  CommonModule,
  ReactiveFormsModule,
  MatFormFieldModule,
  MatSelectModule,
  MaterialCustomModule,
  RouterModule,
  FormsModule,
  AgGridModule,
];

const lumModules = [
  SharedComponentsModule,
  SharedModule,
  UiModule,
  DirectiveModule,
  PipeModule,
  FeatureModule,
  ChannelModule,
];

const pipes = [AppIntegrationIsAttribute];

const standalonePipes = [
  // Standalone pipes
  ParseJsonStringPipe,
];

@NgModule({
  declarations: [...components, ...pipes],
  imports: [...angularModules, ...lumModules, ...standalonePipes],
  exports: [...components],
})
export class AppIntegrationAccountModule {}
